import Component from '@cell/cell-core/component/component';

import './product-variant-selector.scss';

class ProductVariantSelector extends Component {
  constructor() {
    super();

    this.selectedVariant = {
      id: this.parsedDataset.selectedVariantId,
      url: this.parsedDataset.selectedVariantUrl,
      option1: this.parsedDataset.selectedOption1 ?? null,
      option2: this.parsedDataset.selectedOption2 ?? null,
      option3: this.parsedDataset.selectedOption3 ?? null,
      untranslatedVariantTitle: this.parsedDataset.untranslatedVariantTitle,
    };

    this.untranslatedVariantTitles = this.parsedDataset.untranslatedVariantTitles;

    this.handleOptionChange = this.handleOptionChange.bind(this);
  }

  componentDidMount() {
    this.on('product-option-selector.change', this.handleOptionChange);
  }

  async handleOptionChange(event) {
    const { position, value } = event.data;

    // An option that is already selected has been clicked. There is nothing to do in this case.
    if (this.selectedVariant[`option${position}`] === value) return;

    // 1. Update the selected variant.
    await this.updateSelectedVariant(position, value);

    // 2. Notify other components.
    this.emit('change', {
      selectedVariant: this.selectedVariant,
      updatedOption: {
        position,
        value,
      },
    });
  }

  async updateSelectedVariant(optionPosition, optionValue) {
    const { selectedVariant } = this;

    const selectedProductOptions = {
      option1: selectedVariant.option1,
      option2: selectedVariant.option2,
      option3: selectedVariant.option3,
    };

    // Override updated value to find the new selected variant in the next step.
    selectedProductOptions[`option${optionPosition}`] = optionValue;

    // We'll show the loader here while waiting for the data since the user expects some
    // sort of feedback after changing the variant. Best case, the data is already there.
    const loaderElement = document.querySelector('.Loader');
    loaderElement.classList.add('Loader--Active');

    const product = await this.context('product');

    const { variants } = product;

    loaderElement.classList.remove('Loader--Active');

    this.selectedVariant = variants.find(
      ({ option1, option2, option3 }) =>
        option1 === selectedProductOptions.option1 &&
        option2 === selectedProductOptions.option2 &&
        option3 === selectedProductOptions.option3,
    );

    // Add the URL to the selected variant object.
    this.selectedVariant = {
      ...this.selectedVariant,
      url: `${product.url}?variant=${this.selectedVariant.id}`,
    };

    // Add the untranslated title to the selected variant object.
    const variantIndex = variants.findIndex(({ id }) => id === this.selectedVariant.id);

    this.selectedVariant = {
      ...this.selectedVariant,
      untranslatedVariantTitle: this.untranslatedVariantTitles[variantIndex],
    };

    // Only if the product variant selector is the one in the product-main section on the PDP:
    // Update the URL variant param without reloading the page. Also make sure to
    // replace the history instead of pushing it. Otherwise the user might end up going
    // back for ages just to reach the page they were on before.

    if (!this.closest('product-main') || !window.location.pathname.includes('/products/')) return;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', this.selectedVariant.id);

    window.history.replaceState({}, '', url.href);
  }
}

customElements.define('product-variant-selector', ProductVariantSelector);
